module.exports = __webpack_public_path__ + "static/media/bbtapp.2c1ba46b.PNG";